<nav class="main-header navbar navbar-expand navbar-white navbar-light">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" (click)="toggleMenuSidebar.emit()" role="button">
        <i class="fas fa-bars"></i>
      </a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a [routerLink]="['/']" class="nav-link"><i class="fas fa-user-check text-dark-orange"></i>&nbsp;Home</a>
    </li>
    <!--<li class="nav-item d-none d-sm-inline-block">
      <a [routerLink]="['/globalinspection']" class="nav-link"> <i class="fas fa-calendar-check"></i>&nbsp;Bulk Inspection</a>
    </li>-->

  </ul>
  <div class="col-4">
    <p-autoComplete [suggestions]="lines" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                    (completeMethod)="onLineChange($event)" field="fakeName"
                    (onSelect)="onLineSelect($event)"  [forceSelection]="true">
      <ng-template let-device pTemplate="item">
          
          <div class="row align-items-center gap-2">
            <i class="fas fa-desktop"></i>&nbsp;
            <div>{{device.fakeName}}</div>
          </div>
        
      </ng-template>
    </p-autoComplete>
  </div>

  <ul class="navbar-nav ml-auto" style="display:flex">

    &nbsp;
    <span *ngIf="ImgUrl">
      <img [src]="ImgUrl" width="50" />&nbsp;

    </span>
    <span *ngIf="accountName" style="align-self:center">
      Welcome <b style="color: #f16e00;">{{accountName}}</b>
    </span>
    &nbsp;
    <button class="btn btn-outline-danger" (click)="logout()" placement="left" ngbTooltip="Logout">
      <i class="fas fa-sign-out-alt"></i>
    </button>
  </ul>
</nav>


